// extracted by mini-css-extract-plugin
export default {"empty":"CategoryConditions_empty__B2ikO"};